import { groupBy } from 'lodash'
import { Discounts } from './Discounts'
import { OrderParams, OrderPriceSummary } from '../summary/getOrderPriceSummary'
import {
  DiscountConfiguration,
  OrderDiscountConfiguration,
  VariableDiscountConfiguration,
} from '@ca/common/types'
import { applyDiscountsToElements } from './applyDiscountsToElements'
import { validateOrderValues } from '../checkOrderValues'

export type DiscountsByScope = {
  order?: OrderDiscountConfiguration[]
  variable?: VariableDiscountConfiguration[]
}

/**
 * Applies discounts to the order price summary bottom up:
 * 1. Apply discounts to the elements of each item
 * 2. Apply discounts to the order
 */
export const bottomUpStrategy = (
  orderPrice: OrderPriceSummary,
  discounts: DiscountConfiguration[],
  params: OrderParams
): OrderPriceSummary => {
  const discountsByScope = groupBy(discounts, 'scope') as DiscountsByScope

  const items = orderPrice.items.map((item) => {
    const elements = applyDiscountsToElements(
      item.elements,
      discountsByScope.variable
        ?.filter(
          (d) => !item.item.bundleType || d.bundle === item.item.bundleType
        )
        .filter(
          (discount) =>
            !discount.condition ||
            validateOrderValues(
              params.config.conditions[discount.condition],
              item.values,
              params.config
            )?.result
        ) || []
    )

    const total = Discounts.sumItemsWithPrices(elements.values())

    return {
      id: item.id,
      values: item.values,
      price: total,
      elements,
      item: item.item,
    }
  })

  return {
    price: Discounts.applyDiscounts(
      Discounts.sumItemsWithPrices(items),
      discountsByScope.order || []
    ),
    items,
  }
}
